import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-request-location',
  templateUrl: './request-location.component.html',
  styleUrls: ['./request-location.component.scss']
})
export class RequestLocationComponent implements OnInit {
  @Input() content;
  @Output() sendLocation: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  sendLocationClick(event) {
    this.sendLocation.emit(event);
  }

  imageURl(emulatorFiles) {
   return Object.values(emulatorFiles)[0];
  }
}
